export default __webpack_public_path__ + "static/media/photo3.8bbd4abe.jpeg";